export default function StatusBadge({ 
  currentStatus, 
  statusOptions, 
  onStatusChange, 
  type = "default" 
}) {

  const getStatusColor = (status) => {
    const colors = {
      // Property status
      available: 'bg-green-100 text-green-800',
      rented: 'bg-blue-100 text-blue-800',
      maintenance: 'bg-yellow-100 text-yellow-800',
      
      // Booking status
      pending: 'bg-yellow-100 text-yellow-800',
      approved: 'bg-green-100 text-green-800',
      rejected: 'bg-red-100 text-red-800',
      active: 'bg-blue-100 text-blue-800',
      completed: 'bg-gray-100 text-gray-800',
      cancelled: 'bg-red-100 text-red-800',
      
      // Payment status
      failed: 'bg-red-100 text-red-800',
      refunded: 'bg-purple-100 text-purple-800',
      
      // User status
      inactive: 'bg-red-100 text-red-800',
      
      // Maintenance status
      in_progress: 'bg-blue-100 text-blue-800'
    };
    
    return colors[status] || 'bg-gray-100 text-gray-800';
  };

  const handleStatusChange = (e) => {
    onStatusChange(e.target.value);
  };

  return (
    <select
      value={currentStatus}
      onChange={handleStatusChange}
      className={`px-2 py-1 text-xs rounded-full border-0 cursor-pointer focus:ring-2 focus:ring-blue-500 focus:outline-none ${getStatusColor(currentStatus)}`}
    >
      {statusOptions.map((status) => (
        <option key={status} value={status}>
          {status}
        </option>
      ))}
    </select>
  );
}